<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    import Icon from '../icon/Icon.svelte';
    export let title = '';
    export let href = '#';
    export let target;
    export let iconBefore;
    export let iconAfter;
    export let ariaLabel = false;
    export let disabled;
</script>

<style>
    .button-link {
        display: flex;
        align-items: center;
        gap: var(--space-1x);

        &[aria-disabled="true"] {
            color: var(--color-text-disabled);
            cursor: not-allowed;
        }
    }
</style>

<a class="button-link" {href} {target} on:click on:keypress aria-label={ariaLabel ? ariaLabel : title} aria-disabled={disabled}>
    {#if iconBefore}
        <Icon name={iconBefore} />
    {/if}
    {title}
    {#if iconAfter}
        <Icon name={iconAfter} />
    {/if}
</a>
